module.exports = __webpack_public_path__ + "img/kexiangzhengfubutie_image_zy.47a3c646.png";